import { Link, useNavigate } from 'react-router-dom';
import iconSearch from '/img/icon-search.svg';
import iconGear from '/img/icon-gear.svg';
import iconExit from '/img/icon-exit.svg';
import Routes from '../configuration/routes/RouteList';
import NavigationItem from './NavigationItem';
import logOut from '../api/actions/logOut';
import useIsAdmin from '../functions/useIsAdmin';

const Navigation = () => {
  const isAdmin = useIsAdmin();
  const navigate = useNavigate();
  const handleLogout = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    await logOut();
    navigate(Routes.Login);
  };

  return (
    <div className="nm-nav-wrapper">
      <div className="nm-nav">
        <Link to={Routes.Home} className="nm-brand">
          <span className="nm-brand-mark">NM</span>
          <span className="nm-brand-text"><strong>Niu</strong><em>Media</em></span>
        </Link>

        <div className="nm-nav-links">
          <NavigationItem label="home" navigateTo={Routes.Home} />
          <NavigationItem label="channels" navigateTo={Routes.Channels} />
          <NavigationItem label="playlists" navigateTo={Routes.Playlists} />
          {isAdmin && <NavigationItem label="downloads" navigateTo={Routes.Downloads} />}
          <NavigationItem label="upload" navigateTo={Routes.Upload} />
          <NavigationItem label="notes" navigateTo={Routes.Notes} />
        </div>

        <div className="nm-nav-actions">
          <Link to={Routes.Search} className="nm-icon-btn" title="Search">
            <img src={iconSearch} alt="search" />
          </Link>
          <Link to={Routes.SettingsDashboard} className="nm-icon-btn" title="Settings">
            <img src={iconGear} alt="settings" />
          </Link>
          <button className="nm-icon-btn nm-logout" onClick={handleLogout} title="Logout">
            <img src={iconExit} alt="logout" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
